<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>User Management</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/roles' }">Roles</el-breadcrumb-item>
                <el-breadcrumb-item v-if="!roleId">New Role</el-breadcrumb-item>
                <el-breadcrumb-item v-else>Edit Role</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title" v-if="!roleId">
                    Create New Role
                </div>
                <div class="main-title" v-else>
                    Edit Role
                </div>

            </el-col>
            <el-col :span="8" class="text-right">
                <el-button type="success" size="small" @click="saveRole" v-loading="saving" v-if="!roleId">Create Role</el-button>
                <el-button type="success" size="small" @click="saveRole" v-loading="saving" v-else>Update Role</el-button>
            </el-col>
        </el-row>
        <el-row type="flex" style="margin-top: 24px" align="top">
            <el-col :span="24">
                
                    <el-form :rules="rules" ref="form" :model="form"  status-icon >
                    
                        <el-card class="box-card mb-4">
                            <div slot="header" class="clearfix">
                                <span>User Information</span>
                            </div>
                            <div  class="text item">
                                <el-row type="flex" class="row-bg" justify="center" >
                                    <el-col :lg="12" :md="16" :sm="24">
                                        <el-form-item label="Name" prop="name" label-width="100px">
                                            <el-input type="email" v-model="form.name"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Description" prop="description" label-width="100px">
                                            <el-input type="textarea" v-model="form.description"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Active" label-width="100px">
                                            <el-switch v-model="form.active"></el-switch>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>
                    </el-form>

                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>Privileges Setting</span>
                            </div>
                            <div class="text item">
                                    <el-col class="privilege-holder" :lg="12" :sm="24" v-for="privilege in form.privileges" :key="privilege.key" > 
                                        
                                        <el-switch v-model="privilege.active" class="privilege-switch"></el-switch> 
                                        <div class="ml-3 privilege-detail" >
                                            <b>{{privilege.name}}</b> <br />
                                            <div class="privilege-description">{{privilege.description}} </div>
                                        </div>
                                    </el-col>
                            </div>
                        </el-card>
            </el-col>
        </el-row>
    </el-main>
</template>

<script>
import api from '@/services/api/WRCService'
import _ from 'lodash'

export default {
    props: ['roleId'],
    data: function() {
        return {
            loading: false,
            saving: false,
            form: {
                name: '',
                description: '',
                privileges: [
                    { key: 'ADMIN_CONSOLE', name: 'Admin Console', active: false, 
                    description: 'GSR Customer activation record, device management, and password reset.'},
                    { key: 'REPOSSESSED_DEVICE', name: 'Repossessed Device' , active: false,
                    description: 'Management of reposessed GSR devices, assignment of device status, and execution of device ownership transfer.'},
                    { key: 'WEB_FORM_MANAGEMENT', name: 'SR Launcher > Web Form' , active: false,
                    description: 'Web Form (questionnaire) creation and management.'},
                    { key: 'USER_MANAGEMENT', name: 'User > User List & New User', active: false,
                    description: 'Access to both "User List" to view and manage created users and "New User" module to create new user'},
                    { key: 'USER_ROLE_MANAGEMENT', name: 'User > User Roles', active: false,
                    description: 'Manage User Roles defition with module access control'},
                    { key: 'COUNTRY_MANAGEMENT', name: 'Setting > Office Country', active: false,
                    description: 'Management of countries where Grolier has business operation'},
                    { key: 'CITY_MANAGEMENT', name: 'Setting > Office City', active: false,
                    description: 'Management of cities associated with the created countries where Grolier has business operation'},
                    { key: 'OFFICE_MANAGEMENT', name: 'Setting > Office Name', active: false,
                    description: 'Management of Grolier office name record'},
                    { key: 'DEPARTMENT_MANAGEMENT', name: 'Setting > Department', active: false,
                    description: 'Management of Grolier department record, to be associated with user.'},
                    { key: 'SR_COUNTRY_MANAGEMENT', name: 'Setting > GSR Country', active: false,
                    description: 'Management of Countries where Grolier Super Reader is availabel for sale'},
                    { key: 'EMAIL_MANAGEMENT', name: 'Setting > Email Server', active: false,
                    description: 'Management of email server setting for outbound email notifications'}
                ],
                active: true,
            },
        }
    },
    computed: {
        rules() {
            return {
                name: [
                    {required: true, message: "Please enter role name", trigger: 'blur'}
                ],

            }
        },
    },
    methods: {
        saveRole() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let params = {
                        name: this.form.name,
                        description: this.form.description,
                        active: this.form.active,
                    }

                    let privileges = []

                    this.form.privileges.forEach(privilege => {
                        if (privilege.active) {
                            privileges.push(privilege.key)
                        }
                    })

                    params.privileges = privileges

                    this.saving = true

                    if (!_.isUndefined(this.roleId)) {
                        params.roleId = this.roleId
                        api.updateRole(params).then(() => {
                            this.$message({
                                message: 'Successfully Updated Role.',
                                type: 'success'
                            });

                            this.$router.push('/roles')
                        }).catch((error) => {
                            this.$message({
                                message: 'Server error: ' + error.response.status + '.',
                                type: 'error'
                            });
                        }).then(() => {
                            this.saving = false;
                        });
                    } else {
                        api.createRole(params).then(() => {
                            this.$message({
                                message: 'Successfully created Role.',
                                type: 'success'
                            });

                            this.$router.push('/roles')
                        }).catch((error) => {
                            this.$message({
                                message: 'Server error: ' + error.response.status + '.',
                                type: 'error'
                            });
                        }).then(() => {
                            this.saving = false;
                        });
                    }
                }
            })
        },
    },
    mounted() {
        if (!_.isUndefined(this.roleId)) {

            this.saving = true
            api.getRole(this.roleId).then(({data}) => {
                let role = data.data

                this.form.name = role.name
                this.form.description = role.description
                this.form.active = role.active

                role.privileges.forEach(privilege => {
                    let priv = _.find(this.form.privileges, function(c) { return c.key === privilege; });

                    if (!_.isUndefined(priv)) {
                        priv.active = true;
                    }
                })
            }).catch(() => {}).then(() => {
                this.saving = false
            })
        }
    }
}
</script>

<style scoped>
    .el-col.section-col{
        margin-bottom: 20px
    }

    .privilege-holder {
        position: relative;
        padding: 7px;
        font-size: 14px;
    }

    .privilege-switch {
        position: absolute;
    }

    .privilege-detail {
        margin-left: 65px;
        min-height: 70px;
    }

    .privilege-description {
        margin-top: 7px;
        color: #a7a7a7;
    }
</style>